<ng-container *ngIf="data">
  <aside>
    <app-panels *ngIf="data.rightColumnPanels && data.rightColumnPanels.value"  [items]="data.rightColumnPanels.value"></app-panels>
  </aside>

  <div class="main__container">
      <!-- <h1 *ngIf="data.title">{{data.title.value}}</h1>
      <div *ngIf="data.description" [innerHTML]="data.description.value"></div>
      <app-picture *ngIf="data.banner" [data]="data.banner.value"></app-picture> -->

      <app-panels *ngIf="data.panels && data.panels.value"  [items]="data.panels.value"></app-panels>
  </div>
</ng-container>
